import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=1b40784f&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=js&"
export * from "./DetailList.vue?vue&type=script&lang=js&"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=1b40784f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40784f",
  null
  
)

export default component.exports